/**
 * Project : workspace
 * File    : CreateStockScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.stock.create

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.business.feature.businessConfig.viewModel.BusinessConfigViewModel
import com.parmartechnologies.commerce.feature.alert.handler.AlertHandler
import com.parmartechnologies.commerce.feature.inventory.product.viewModel.ProductViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.inventory.InventoryViewModel
import com.parmartechnologies.core.feature.currency.model.Currency
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.ui.component.image.ImageView
import component.button.DefaultButton
import component.button.SecondaryButton
import component.input.CheckBoxInput
import component.input.PriceInputField
import component.input.QuantityInputField
import component.input.TaxInputField
import component.input.TextInputField
import component.loader.AppLoader
import component.navigation.TopNavBar
import engine.pricing.PricingEngine
import locale.localization
import navigation.AppNavigator
import presentation.screens.business.inventory.category.component.SelectCategoryRow
import presentation.screens.business.inventory.component.SelectBrandRow
import presentation.screens.business.inventory.component.SelectCouponRow
import presentation.screens.business.inventory.component.SelectProductColorRow
import presentation.screens.business.inventory.component.SelectSizeRow
import presentation.screens.business.inventory.component.SelectTagRow
import presentation.screens.business.inventory.component.SelectUOMRow
import presentation.screens.business.inventory.stock.component.ProductCard
import presentation.screens.business.inventory.sub_category.component.SelectSubCategoryRow
import theme.ThemeColor

/**
 * Represents the create stock screen class.
 */

class CreateStockScreen{
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val configViewModel = BusinessConfigViewModel()
        val businessConfig = configViewModel.businessConfig.collectAsState()
        val currency = businessConfig.value?.currency ?: Currency()
        val viewModel = ProductViewModel(business = myBusiness.value)
        val invViewModel = InventoryViewModel(business = myBusiness.value)
        val product = AppNavigator.shared().getNavigationParam().product
        val currentStep = viewModel.productFormIndex.collectAsState()
        
        val name = remember { mutableStateOf("") }
        val model = remember { mutableStateOf("") }
        val Barcode = remember { mutableStateOf("") }
        val brandId = remember<MutableState<String>> { mutableStateOf("") }
        val tagId = remember<MutableState<String>> { mutableStateOf("") }
        val uomId = remember<MutableState<String>> { mutableStateOf("") }
        val qty = remember { mutableStateOf(0L) }
        val colorId = remember<MutableState<String>> { mutableStateOf("") }
        val sizeId = remember<MutableState<String>> { mutableStateOf("") }
        val discountId = remember<MutableState<String>> { mutableStateOf("") }
        val couponId = remember<MutableState<String>> { mutableStateOf("") }
        val categoryId = remember<MutableState<String>> { mutableStateOf("") }
        val subCategoryId = remember<MutableState<String>> { mutableStateOf("") }
        val costPrice = remember { mutableStateOf(0.0) }
        val mrpPrice = remember { mutableStateOf(0.0) }
        val price = remember { mutableStateOf(0.0) }
        val discountPrice = remember { mutableStateOf(0.0) }
        val salesPrice = remember { mutableStateOf(0.0) }
        val finalPrice = remember { mutableStateOf(0.0) }
        val cgstTax = remember { mutableStateOf(0.0) }
        val sgstTax = remember { mutableStateOf(0.0) }
        val igstTax = remember { mutableStateOf(0.0) }
        val description = remember { mutableStateOf("") }
        val totalTax = remember { mutableStateOf(0.0) }
        var taxIncluded by remember { mutableStateOf( false) }
        /**
 * Executes the on click save operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
        fun onClickSave() {
            var isTaxIncluded = 0
            if(taxIncluded){
                isTaxIncluded = 1
            }
            invViewModel.createInventory(
                name = name.value,
                description = description.value,
                productId = product!!._id,
                categoryId = categoryId.value,
                subCategoryId = subCategoryId.value,
                model = model.value,
                Barcode = Barcode.value,
                brandId = brandId.value,
                tagId = tagId.value,
                uomId = uomId.value,
                colorId = colorId.value,
                qty = qty.value,
                sizeId = sizeId.value,
                discountId = discountId.value,
                couponId = couponId.value,
                costPrice = costPrice.value,
                mrp = mrpPrice.value,
                discount = discountPrice.value,
                salePrice = salesPrice.value,
                price = price.value,
                finalPrice = finalPrice.value,
                cgst = cgstTax.value,
                sgst = sgstTax.value,
                igst = igstTax.value,
                currency = currency,
                taxIncluded = isTaxIncluded,
                totalTax = totalTax.value
            ) {
                if (it) {
                    AppNavigator.shared().goBack()
                } else {
                    AlertHandler.shared().showAlert(
                        localization().product.productsAlertTitle,
                        localization().product.productsAlertMessage/*"Oops!", "Something went wrong"*/
                    )
                }
            }
        }
        /**
 * Executes the calculate tax operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
        fun calculateTax(){
            val amount = price.value - discountPrice.value
            val totalTaxPercent = cgstTax.value + sgstTax.value + igstTax.value
            val taxedAmount = PricingEngine().calculateTax(taxIncluded, amount, totalTaxPercent)
            if(taxIncluded){
                salesPrice.value = amount - taxedAmount
                finalPrice.value = amount
            }else{
                salesPrice.value = (amount)
                finalPrice.value = (amount + taxedAmount)
            }
            totalTax.value = taxedAmount
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = localization().inventory.inventoryCreate, NavigationParam(), onBackPress = {
                if (currentStep.value == 0) {
                    AppNavigator.shared().goBack()
                } else {
                    viewModel.setProductFormIndex(currentStep.value - 1)
                }
            })
            AppLoader(viewModel)
            LazyColumn(
                modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.84f)
                    .padding(start = 8.dp, end = 8.dp, bottom = 20.dp)
            ) {
                item {
                    ProductCard(product, invViewModel)
                }
                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        TextInputField(
                            title = "Inventory Name",
                            "Inventory Name",
                            value = name.value
                        ) {
                            name.value = it
                        }
                    }
                }
                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        TextInputField(
                            title = "Model No.",
                            "Model Number",
                            value = model.value
                        ) {
                            model.value = it
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        TextInputField(
                            title = "Barcode No.",
                            "Barcode Number",
                            value = Barcode.value
                        ) {
                            Barcode.value = it
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        SelectBrandRow(brandId.value) {
                            brandId.value = it._id
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        SelectTagRow(tagId.value) {
                            tagId.value = it._id
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        SelectUOMRow(uomId.value) {
                            uomId.value = it._id
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        QuantityInputField(
                            title = "Quantity",
                            "Enter Quantity",
                            value = qty.value
                        ) {
                            qty.value = it
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        SelectProductColorRow(colorId.value) {
                            colorId.value = it._id
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        SelectSizeRow(sizeId.value) {
                            sizeId.value = it._id
                        }
                    }
                }

//                item {
//                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
//                        SelectDiscountRow(discountId.value) {
//                            discountId.value = it._id
//                        }
//                    }
//                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        SelectCouponRow(couponId.value) {
                            couponId.value = it._id
                        }
                    }
                }

                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        Row(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                            Box(
                                modifier = Modifier.fillMaxWidth().height(90.dp).weight(0.5f)
                            ) {
                                PriceInputField(
                                    title = "Cost Price",
                                    "Cost Price",
                                    currency,
                                    costPrice.value,
                                    false
                                ) {
                                    costPrice.value = it
                                }
                            }
                            Box(
                                modifier = Modifier.fillMaxWidth().height(90.dp).weight(0.5f)
                            ) {
                                PriceInputField(
                                    title = "MRP",
                                    "Enter MRP",
                                    currency,
                                    mrpPrice.value,
                                    false
                                ) {
                                    mrpPrice.value = it
                                    calculateTax()
                                }
                            }
                        }
                        Row(modifier = Modifier.fillMaxWidth().height(90.dp)) {
                            Box(
                                modifier = Modifier.fillMaxWidth().wrapContentHeight().weight(0.5f)
                            ) {
                                PriceInputField(
                                    title = "Price",
                                    "Price",
                                    currency,
                                    price.value,
                                    false
                                ) {
                                    price.value = it
                                    calculateTax()
                                }
                            }
                            Box(
                                modifier = Modifier.fillMaxWidth().wrapContentHeight().weight(0.5f)
                            ) {
                                PriceInputField(
                                    title = "Sale Price",
                                    "Sale Price",
                                    currency,
                                    salesPrice.value,
                                    true
                                ) {
                                    salesPrice.value = it
                                }
                            }
                        }
                        PriceInputField(
                            title = "Final Price",
                            "Final Price",
                            currency,
                            finalPrice.value,
                            true
                        ) {
                            finalPrice.value = it
                        }

                        PriceInputField(
                            title = "Discount",
                            "Discount",
                            currency,
                            discountPrice.value,
                            false
                        ) {
                            discountPrice.value = it
                            calculateTax()
                        }


                    }
                }
                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        CheckBoxInput("Tax Inclusive in MRP", taxIncluded) {
                            taxIncluded = it
                            calculateTax()
                        }
                        TaxInputField(title = "CGST", "Enter CGST", cgstTax.value) {
                            cgstTax.value = it
                            calculateTax()
                        }
                        TaxInputField(title = "SGST", "Enter SGST", sgstTax.value) {
                            sgstTax.value = it
                            calculateTax()
                        }
                        TaxInputField(title = "IGST", "Enter IGST", igstTax.value) {
                            igstTax.value = it
                            calculateTax()
                        }
                        SelectCategoryRow(myBusiness.value,categoryId.value) {
                            categoryId.value = it._id
                        }
                        if (categoryId.value.isNotEmpty() == true) {
                            SelectSubCategoryRow(subCategoryId.value, categoryId.value) {
                                subCategoryId.value = it._id
                            }
                        }
                        Box(modifier = Modifier.fillMaxWidth().height(200.dp)) {
                            ImageView("", "",true)
                        }
                        TextInputField(
                            title = "Description",
                            "Enter Description",
                            description.value
                        ) {
                            description.value = it
                        }
                    }
                }
            }

            Row(modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.16f)) {
                SecondaryButton("Cancel", {
                    AppNavigator.shared().goBack()
                })
                DefaultButton(localization().button.saveButton/*"Next"*/, onClick = {
                    onClickSave()
                })
            }
        }
    }
}